const STYLES = {
  scheduled: "border-blue-500/40 bg-blue-500/10 text-blue-400",
  in_progress: "border-emerald-500/40 bg-emerald-500/10 text-emerald-400",
  final: "border-zinc-600 bg-zinc-800/60 text-zinc-300",
  postponed: "border-yellow-500/40 bg-yellow-500/10 text-yellow-400",
  canceled: "border-red-500/40 bg-red-500/10 text-red-400",
};

const LABELS = {
  scheduled: "Scheduled",
  in_progress: "Live",
  final: "Final",
  postponed: "Postponed",
  canceled: "Canceled",
};

export const GameStatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-wide ${
      STYLES[status] || STYLES.scheduled
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full bg-current ${status === "in_progress" ? "animate-pulse" : ""}`} />
    {LABELS[status] || status || "Unavailable"}
  </span>
);
